export const comments_3296369 = {"data":{"data":[],"links":{}}}